import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import PaperHeader from '../components/PaperHeader'
import { pageLoaded } from './utils'

export default class Dashboard extends Component {
  componentDidMount() {
    pageLoaded('Dashboard')
  }

  render() {
    return (
      <Paper zDepth={2}>
        <PaperHeader title='Dashboard' />
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/Dashboard.js